var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCloseIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cerrar-simbolo-de-boton-circular",
    width: 20.26,
    height: 20.26,
    viewBox: "0 0 20.26 20.26",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_0_41_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M13.75,6.511a.637.637,0,0,0-.9,0L10.127,9.231,7.444,6.549a.633.633,0,0,0-.9.9l2.683,2.683-2.7,2.7a.638.638,0,0,0,.9.9l2.7-2.7,2.683,2.683a.633.633,0,1,0,.9-.9l-2.683-2.683L13.75,7.413A.637.637,0,0,0,13.75,6.511ZM10.13,0A10.13,10.13,0,1,0,20.26,10.13,10.13,10.13,0,0,0,10.13,0Zm0,18.994a8.864,8.864,0,1,1,8.864-8.864A8.864,8.864,0,0,1,10.13,18.994Z",
    fill: "#FFFFFF"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-icon.da66823c.svg";
export { ForwardRef as ReactComponent };